module.exports = __webpack_public_path__ + "img/cogswell_thumb.9069fa19.jpg";